/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - Start*/
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzLoader, BzTab, BzTabs } from "../../components";
import { DontMiss, Recommendations, Events } from '../../containers';
import News from '../News/News';
import Analysis from './Analysis';
import SideAlerts from '../Watchlist/Sidebar/SideAlerts';
import { useSelector } from 'react-redux';
import { WATCHLIST_GRID_INDEX, FACILITY_NUM, APP_INFO_PARAMS, NEWS_CMOT_MODE } from '../../utils/global_variables';
import { getAppInfoData } from '../../utils/global_functions';
import _ from 'lodash';


const AnalyticsTabs = ({ arrGridRowData, objPortfolioSumaary, arrRecommendationsInfo, setActiveEvent, activeEvent, isGlobalSearch,
    events, objEvent, nActiveCardIndex, nASetActiveCardIndex, activePage, areaChartConfig, expand, setExpand, activeTabkey, setActiveTabkey, ...props }) => {
    const modals = useSelector(state => state.modals.modals);
    const EventsRef = useRef();
    const objCFT = useSelector(state => state?.auth?.objCFT);//ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing 
    let tabs = [];
    const [componentTab, setComponentTab] = useState(activeTabkey);
    const [spinner, setSpinner] = useState(false);
    const handleTabkeyChange = (tabkey) => {
        setActiveTabkey(tabkey);
        setComponentTab(tabkey);
    };
    useEffect(() => {
        if (nCMOTMode !== NEWS_CMOT_MODE?.CMOT_OFF) {
            tabs = [
                "analysis",
                "news",
                "events",
                "dont_miss",
                "recommendations",
                "alerts"
            ];
        } else {
            tabs = [
                "analysis",
                "dont_miss",
                "recommendations",
                "alerts",
            ];
        }
    });

    // const handleExpand = () => {
    //     setExpand(!expand);
    // };
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const dontMissData = useSelector(state => state?.dontMiss?.dontMissData);

    const arrHoldingsDontMiss = useMemo(() => {
        const arrHolding = dontMissData?.filter((item) => holdingsScrips?.length > 0 && holdingsScrips?.some((holding) => `${holding?.nMarketSegmentId}_${holding?.nToken}` === item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        return arrHolding;
    }, [dontMissData, holdingsScrips]);

    // ---BT-117131_SrikanthRao_02-02-2024 ||NEWS CMOTMode Implementation
    const nCMOTMode = getAppInfoData(APP_INFO_PARAMS.APP_CMOT_MODE);

    const handleComponentTab = (tabKey) => {
        setComponentTab(tabKey);
        setSpinner(false);
    };

    const debounceChange = useCallback(_.debounce(handleComponentTab, 2000), []);
    const bIsAnyModalOpen = useMemo(() => {

        return Object.keys(modals)?.some((eachModal) => modals[eachModal]);

    }, [modals]);

    const handleTabChange = useCallback((e) => {
        let key = e?.key;
        let shiftKey = e?.shiftKey;
        let index = tabs.findIndex(x => x === activeTabkey);
        if (!isGlobalSearch && !bIsAnyModalOpen) {
            e?.preventDefault();
            e?.stopPropagation();

            if (key === "Tab") {
                e?.preventDefault();
                e?.stopPropagation();
                if (shiftKey) {
                    e?.preventDefault();
                    e?.stopPropagation();
                    if (index === 0) {
                        setActiveTabkey(tabs[index]);
                        debounceChange(tabs[index]);
                    } else {
                        setActiveTabkey(tabs[index - 1]);
                        debounceChange(tabs[index - 1]);
                        setSpinner(true);
                    }
                } else {
                    if (index === tabs?.length - 1) {
                        setActiveTabkey(tabs[index]);
                        debounceChange(tabs[index]);
                    } else {
                        setActiveTabkey(tabs[index + 1]);
                        debounceChange(tabs[index + 1]);
                        setSpinner(true);
                    }
                }
            }
        }


    }, [activeTabkey, debounceChange, isGlobalSearch, setActiveTabkey, tabs, bIsAnyModalOpen]);

    useEffect(() => {
        if (activePage) {
            document.removeEventListener('keydown', handleTabChange);
        } else if (activePage !== null) { //Ameersha N--Changed condition need to add listner only this content is active onClik ,as foucs is on Holdings Grid
            document.addEventListener('keydown', handleTabChange);
        }
        return () => {
            document.removeEventListener('keydown', handleTabChange);
        };
    }, [activePage, handleTabChange]);

    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0'>
                    <Col md={12} className='d-flex justify-content-start align-items-center'>
                        <BzTabs className='nav nav-tabs' data-testid="portfolio-analytics-tabs-container">
                            {/* ManasaB : 05-07-2024 : Hotfix changes  - Start*/}
                            <BzTab data-testid="portfolio-analytics-analysis-tab" className='nav-link color-subtext' tabKey='analysis' isActive={activeTabkey === 'analysis'} onClick={handleTabkeyChange.bind(this, 'analysis')} >Analysis</BzTab>
                            {nCMOTMode !== NEWS_CMOT_MODE?.CMOT_OFF
                                ?
                                <>
                                    <BzTab data-testid="portfolio-analytics-news-tab" className='nav-link color-subtext' tabKey='news' isActive={activeTabkey === 'news'} onClick={handleTabkeyChange.bind(this, 'news')}>News</BzTab>
                                    <BzTab data-testid="portfolio-analytics-events-tab" className='nav-link color-subtext' tabKey='events' isActive={activeTabkey === 'events'} onClick={handleTabkeyChange.bind(this, 'events')}>Events</BzTab>
                                </> : null
                            }
                            <BzTab data-testid="portfolio-analytics-dont-miss-tab" className='nav-link color-subtext' tabKey='dont_miss' isActive={activeTabkey === 'dont_miss'} onClick={handleTabkeyChange.bind(this, 'dont_miss')}>Don't Miss {`(${arrHoldingsDontMiss?.length})`} </BzTab>
                            {/* ManasaB : 05-07-2024 : Hotfix changes  - End*/}
                            <BzTab data-testid="portfolio-analytics-recommendations-tab" className='nav-link color-subtext' tabKey='recommendations' isActive={activeTabkey === 'recommendations'} onClick={handleTabkeyChange.bind(this, 'recommendations')}>Recommendations</BzTab>
                            {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing --Start */}
                            {objCFT.ALERT === FACILITY_NUM.ON ? <BzTab data-testid="portfolio-analytics-alerts-tab" className='nav-link color-subtext' tabKey='alerts' isActive={activeTabkey === 'alerts'} onClick={handleTabkeyChange.bind(this, 'alerts')}>Alerts</BzTab> : null}
                            {/* ManasaB : 23/11/2023 : BT-115296 Calculator Bug Fixing --end */}

                        </BzTabs>
                    </Col>
                    {/* commented the expand and collapse as removed in latest  pdf will remove code later Azeem k 30-10-2023 */}

                    {/* <Col md={1} className='d-flex justify-content-end align-items-center'>
                        <BzToolTip placement='bottom' TooltipMsg={`${expand ? 'Collapse' : 'Expand'}`}>
                            <div className={`icon-16 icon-dark ${expand ? 'icon-collapse' : 'icon-expand'}`} onClick={handleExpand} />
                        </BzToolTip>
                    </Col> */}
                </Row>
                <Row className='g-0 my-4'> {/* Hari P: 12-11-2023 SAT-BT-107432 2nd Cycle  UI issue fixed */}
                    <Col>
                        {spinner ? <div className='zero-state-alerts zero-state-alerts-xl'>
                            <BzLoader spinner={spinner} />
                        </div> :
                            <>
                                {

                                    componentTab === 'analysis' ? <Analysis arrGridRowData={arrGridRowData} objPortfolioSumaary={objPortfolioSumaary} areaChartConfig={areaChartConfig} expand={expand} /> :

                                        componentTab === 'dont_miss' ? <div className='portfolio-wrapper'><DontMiss nActiveCardIndex={nActiveCardIndex} nASetActiveCardIndex={nASetActiveCardIndex} /></div> :

                                            componentTab === 'news' ? <div className='portfolio-wrapper'><News /></div> :

                                                componentTab === 'events' ? <div className='portfolio-wrapper'><Events onChipChange={setActiveEvent} id={activeEvent} events={events} objEvent={objEvent} EventsRef={EventsRef} /></div> :

                                                    componentTab === 'recommendations' ? <div className='portfolio-wrapper'><Recommendations objLayOut={{ horizonatal: true, wrap: false }} arrRecommendationsInfo={arrRecommendationsInfo} /></div> :

                                                        componentTab === 'alerts' ? <div className='portfolio-wrapper'><SideAlerts AlertPortfolio={true} /></div> : null
                                }</>
                        }
                    </Col>
                </Row>
            </Container>
        </>


    );
};

export default memo(AnalyticsTabs);

/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - End*/